export default "__VITE_ASSET__d39f5184__"